;(function() {
  'use strict'

  angular.module('core.spFooter', [])
})()
